// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "心理健康与调适",
      "tec": "刘清池",
      "week": "6-15周",
      "add": "实训E224智慧心理云会议中心"
    },
    {
      "sub": "体育",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    {
      "sub": "思想道德与法治",
      "tec": "梁春娥",
      "week": "6-17周",
      "add": "教学楼C座305教务"
    },
    {
      "sub": "人工智能与计算机应用软件",
      "tec": "刘勇",
      "week": "6-17周",
      "add": "实训楼C座303"
    },
    {
      "sub": "数字电子技术",
      "tec": "梁岱立",
      "week": "6-16周",
      "add": "108国教"
    }
  ],
  "2": [
    [
      {
        "sub": "综合英语1",
        "tec": "刘德娟",
        "week": "6-18周",
        "add": "动1"
      },
      {
        "sub": "105国教",
        "tec": "钱祺",
        "week": "6-18周",
        "add": "动1"
      },
      {
        "sub": "101国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "动1"
      },
      {
        "sub": "107国教",
        "tec": "于轶",
        "week": "6-18周",
        "add": "动1"
      }
    ],
    {
      "sub": "高等数学",
      "tec": "白景来",
      "week": "6-19周",
      "add": "教学楼A座322电力"
    },
    {
      "sub": "电工基础",
      "tec": "SYED M ALI孟垂懿",
      "week": "6-16周",
      "add": "105国教"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "交际口语1",
        "tec": "外教6",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "105国教",
        "tec": "外教8",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "6-18周",
        "add": "动2"
      }
    ],
    {
      "sub": "高等数学",
      "tec": "白景来",
      "week": "6-19周",
      "add": "教学楼A座221电力"
    },
    0,
    0,
    {
      "sub": "军事理论",
      "tec": "孔瀚",
      "week": "14-18周",
      "add": "教学楼C座113教务"
    }
  ],
  "4": [
    {
      "sub": "思想道德与法治",
      "tec": "梁春娥",
      "week": "6-17周",
      "add": "教学楼C座115教务"
    },
    [
      {
        "sub": "综合英语1",
        "tec": "钱祺",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "101国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "107国教",
        "tec": "于轶",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "109国教",
        "tec": "刘德娟",
        "week": "6-18周",
        "add": "动2"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "王树平",
      "week": "6-9周",
      "add": "教学楼A座225电力"
    },
    {
      "sub": "数字电子技术",
      "tec": "梁岱立",
      "week": "6-16周",
      "add": "108国教"
    },
    {
      "sub": "就业创业指导",
      "tec": "刘思园",
      "week": "14-18周",
      "add": "教学楼C座113教务"
    }
  ],
  "5": [
    {
      "sub": "高等数学",
      "tec": "白景来",
      "week": "6-19周",
      "add": "教学楼A座321电力"
    },
    {
      "sub": "电工基础",
      "tec": "SYED M ALI孟垂懿",
      "week": "6-16周",
      "add": "107国教"
    },
    {
      "sub": "人工智能与计算机应用软件",
      "tec": "刘勇",
      "week": "6-17周",
      "add": "实训楼C座303"
    },
    {
      "sub": "军事理论",
      "tec": "孔瀚",
      "week": "15-18周",
      "add": "教学楼C座113教务"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
